<template>
    <auth-layout
        :progress="isUserComingFromLogin ? 0 : progress"
        :isPlain="isUserComingFromLogin"
        :isProgressBarHidden="true"
        class="aligned-left"
    >
        <template #byword>
            <span v-html="$t('pages.auth.signup.steps.congratulations.byword')"></span>
        </template>

        <template #default>
            <common-content-wrapper width="small">
                <common-page-header :heading="pageHeading" :content="pageContent"></common-page-header>
            </common-content-wrapper>

            <template>
                <common-content-wrapper width="small">
                    <common-content-spacer height="large">
                        <div v-if="isUserComingFromLogin">
                            <p
                                v-html="
                                    $t('pages.auth.signup.steps.congratulations.please_use_confirmation_link', {
                                        email: $route.query.email,
                                    })
                                "
                            ></p>
                        </div>
                        <div class="page-copy">
                            <div v-if="!isUserComingFromLogin">
                                <p class="page-copy__center">
                                    <svg><use xlink:href="#picture-email-sent" /></svg>
                                </p>

                                <p
                                    v-html="
                                        $t('pages.auth.signup.steps.congratulations.content.intro', {
                                            email: $route.query.email,
                                        })
                                    "
                                ></p>
                            </div>

                            <hr />

                            <p>
                                <!-- prettier-ignore -->
                                <template v-if="isSendingVerificationEmail || isVerificationEmailSent">
                                    <b>{{ resendButtonLabel }}</b><span v-if="isVerificationEmailSent">.</span>
                                </template>
                                <template v-else>
                                    <p>{{ $t('pages.auth.signup.steps.congratulations.content.cant_find') }}</p>

                                    <button type="button" @click="resendVerificationEmail()">
                                        {{ resendButtonLabel }}
                                    </button>
                                    - {{ $t('pages.auth.signup.steps.congratulations.content.footer') }}
                                </template>
                            </p>
                        </div>
                    </common-content-spacer>
                </common-content-wrapper>
            </template>
        </template>
    </auth-layout>
</template>

<script>
    import SignupPageMixin from 'mixins/SignupPageMixin'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import UsersAPI from 'api/UsersAPI'
    import AuthAPI from 'api/AuthAPI'
    import GoogleAnalyticsService from 'services/GoogleAnalyticsService'

    export default {
        mixins: [SignupPageMixin, ScreenSizeDetectionMixin],

        components: {
            AuthLayout,
        },

        data() {
            return {
                isSendingVerificationEmail: false,
                isVerificationEmailSent: false,
                isUserComingFromLogin: false,
            }
        },

        computed: {
            userId() {
                return this.$route.query.email
            },
            resendButtonLabel() {
                if (this.isSendingVerificationEmail) {
                    return this.$t('pages.auth.signup.steps.congratulations.content.button.sending')
                }

                if (this.isVerificationEmailSent) {
                    return this.$t('pages.auth.signup.steps.congratulations.content.button.sent')
                }

                return this.$t('pages.auth.signup.steps.congratulations.content.button.send')
            },

            pageHeading() {
                return this.isUserComingFromLogin
                    ? this.$t('pages.auth.signup.steps.congratulations.validate_heading')
                    : this.$t('pages.auth.signup.steps.congratulations.heading')
            },

            pageContent() {
                return this.isUserComingFromLogin ? '' : this.$t('pages.auth.signup.steps.congratulations.description')
            },
        },

        methods: {
            resendVerificationEmail() {
                if (this.isSendingVerificationEmail || this.isVerificationEmailSent) {
                    return
                }

                this.isSendingVerificationEmail = true

                AuthAPI.resendVerificationEmail(this.$route.query.email, this.$route.query.id).then(() => {
                    this.isSendingVerificationEmail = false
                    this.isVerificationEmailSent = true
                })
            },

            proceedToDashboard() {
                this.$auth.logOut()
                this.$router.push({ name: 'auth.login' })
            },
        },

        mounted() {
            if (!this.$router.previousRoute) {
                return
            }
            if (process.env.VUE_APP_ENV === 'production' && !this.$auth.getUser().isNotificationSentOnRegister) {
                UsersAPI.sendNewMemberRegisteredNotificationEmail()
            }

            GoogleAnalyticsService.emitRegistrationCompletedGoogleAnalytics(this.$ga)
        },

        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.isUserComingFromLogin = from.path === '/login'
            })
        },
    }
</script>

<style lang="scss" scoped>
    .aligned-left {
        text-align: left;
    }
</style>
